import * as React from "react";
import { TooltipFormat } from "./range-component-props";
//import "./range-component.css";
import { Timecode } from "./timecode";
import RangeComponentState from './range-component-state';
export type RangeComponentProps = {
  /**
   *  Data to load Range
   */
  data: RangeComponentData;
  /**
   *  Events for the Range
   */
  events?: RangeComponentEvents;
  /**
   *  Additional options for Range to enable different interfaces like Model etc.
   */
  options?: RangeComponentOptions;
  /**
   *  Additional id passed to Range
   */
  testId?: string;
};

export type RangeComponentData = {
  mute?: boolean;
  valueMax: number;
  accessabiltyText?: string;
  chapteredVideoData?: any;
  reportTitle?: string;
};

export type RangeComponentOptions = {
  preview?: string | any;
  ghost?: boolean;
  tooltipFormat?: TooltipFormat;
  tooltip?: boolean;
  reflect?: number;
  className?: string;
  title?: string;
  modal?: boolean;
};

export type RangeComponentEvents = {
  update(value: number): void;
};

export class RangeComponent extends React.Component<
  RangeComponentProps,
  RangeComponentState
> {
  state!: RangeComponentState;
  private x: number;
  private dragging: boolean = false;
  private value: number = 0;
  private valueMax: number = 10;
  private handleWidth: number = 0;
  private ref: any;

  constructor(props: RangeComponentProps) {
    super(props);
    this.x = 0;
    this.value =
      this.props.options && this.props.options.reflect
        ? (this.props.options.reflect / this.props.data.valueMax) * 100
        : 0;
    this.ref = React.createRef();
    this.getStyle = this.getStyle.bind(this);
    this.renderToolTipText = this.renderToolTipText.bind(this);
    this.handleMouseAndTouch = this.handleMouseAndTouch.bind(this);
    this.handleKeyEvents = this.handleKeyEvents.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }

  componentDidMount() {
    window.addEventListener<'resize'>('resize', this.onWindowResize);
    this.x = this.getWidth() * (this.value / 100);
    this.forceUpdate();
  }

  componentWillReceiveProps(nextProp: RangeComponentProps) {
    if (!this.dragging && nextProp.options?.reflect !== this.props.options?.reflect) {
      this.x = this.getWidth() * (this.value / 100);
      this.value =
        nextProp.options && nextProp.options.reflect
          ? (nextProp.options.reflect / nextProp.data.valueMax) * 100
          : 0;
      this.forceUpdate();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  onWindowResize(e: UIEvent) {
    this.x = this.getWidth() * (this.value / 100);
    this.forceUpdate();
  }

  render() {
    // return (<div data-test-id={this.props.testId} >RangeComponent Component</div>);
    const previewClass =
      "RangeComponent__tooltip bg-att-blue font-regular" +
      ' ' +
      (!this.props?.options?.preview ? '' : "RangeComponent__tooltipPreview");
    const ttPrvTxtClass = !this.props?.options?.preview
      ? ''
      : "RangeComponent__tooltipPreviewText";
    const nowStyle = this.getStyle(); // only call this once and reuse
    const customClass = this.props.options && this.props.options.className;
    const playerControls = this.props.options?.modal ? ' player_controls' : ' ';
    return (
      <>
      {/*
              // @ts-ignore */}
              <style jsx global>{`
              .RangeComponent__component {
                position: relative;
                cursor: pointer;
                display: flex;
                align-items: center;
              }
              .RangeComponent__component:focus {
                outline: 1px dotted;
                outline-color: inherit;
              }
              
              .RangeComponent__mask {
                position: relative;
                width: 100%;
                height: 100%;
                overflow: visible;
              }
              
              .RangeComponent__bottom {
                height: 100%;
                width: 100%;
                background-color: #686e74;
                z-index: 99995;
                height: 5px;
                border-radius: 3px;
              }
              
              .RangeComponent__top {
                position: absolute;
                height: 100%;
                z-index: 99997;
                border-radius: 3px 0 0 3px;
                height: 5px;
              }
              
              .RangeComponent__arrow {
                position: absolute;
                border-left: 5px solid transparent;
                border-right: 5px solid transparent;
                border-bottom: 10px solid #009fdb;
                display: inline-block;
                vertical-align: middle;
                width: 0;
                height: 0;
                top: 8px;
              }
              
              .RangeComponent__button {
                position: absolute;
                left: 0;
                width: 18px;
                z-index: 99999;
                cursor: pointer;
                height: 13px;
                border: 1px solid #009fdb;
                border-radius: 50%;
                width: 13px;
                background: #00374a;
                transition: width 0.1s, height 0.1s;
              }
              
              .RangeComponent__button.RangeComponent__hover {
                height: 15px;
                width: 15px;
              }
              
              .RangeComponent__ghost {
                position: absolute;
                height: 10px;
                left: 0;
                border-radius: 10px;
                width: 18px;
                z-index: 99999;
                cursor: pointer;
              }
              
              .RangeComponent__tooltip {
                border-radius: 3px;
                transform: translate(-50%, -100%);
                color: #1d2329;
                font-size: 1.4rem;
                position: absolute;
                padding: 6px;
                box-sizing: border-box;
                border-radius: 4px;
                z-index: 999999;
                text-align: center;
                pointer-events: none;
                white-space: nowrap;
                transform: translate(-50%, -100%);
                background-repeat: no-repeat;
              }
              
              .RangeComponent__tooltipPreview {
                width: 150px;
                height: 87px;
                border: 1px solid #009fdb;
                background-repeat: no-repeat;
                background-size: 8850px 87px;
                padding: 0px;
              }
              
              .RangeComponent__tooltipPreviewText {
                width: 100%;
                left: 50%;
                top: 100%;
                transform: translate(-50%, -100%);
              }
              @media screen and (min-width: 601px) {
                .player_controls {
                display: flex !important;
                }
              }              
              `}</style>
      <div
        className={customClass + ' ' + "RangeComponent__component" + playerControls }
        tabIndex={0}
        role="slider"
        aria-label={this.props.data.accessabiltyText}
        // aria-valuemin="0"
        // aria-valuemax="1"
        aria-orientation="horizontal"
        // aria-valuenow="0"
        aria-valuetext="0"
        report-title={this.props.data.reportTitle || 'Slider'}
        onMouseDown={this.handleMouseAndTouch}
        onMouseUp={this.handleMouseAndTouch}
        onMouseMove={this.handleMouseAndTouch}
        onTouchStart={this.handleMouseAndTouch}
        onTouchEnd={this.handleMouseAndTouch}
        onKeyDown={this.handleKeyEvents}
        onKeyUp={this.handleKeyEvents}
        ref={this.ref}
      >
        <div style={{ position: 'relative', flex: '1 1 auto' }}>
          <div
            className={
              "RangeComponent__bottom bg-gray-600" + (this.dragging ? ' ' + "RangeComponent__hover" : '')
            }
            style={nowStyle.bottom}
          />
          <div
            className={"RangeComponent__top bg-att-blue" + (this.dragging ? ' ' + "RangeComponent__hover" : '')}
            style={nowStyle.top}
          />
          {this.props?.options?.ghost ? (
            <div className={"RangeComponent__ghost bg-white"} style={nowStyle.ghost} />
          ) : (
            ''
          )}
          <div
            className={
              "RangeComponent__button" + (this.dragging ? ' ' + "RangeComponent__hover" : '')
            }
            style={nowStyle.button}
            report-title={this.props.data.reportTitle}
          />
          <div
            className={previewClass}
            style={nowStyle.tooltip}
            role="tooltip"
            aria-hidden="true"
          >
            <div className={ttPrvTxtClass}>
              {nowStyle.tooltip.display !== 'none'
                ? this.renderToolTipText()
                : '0:00'}
            </div>
          </div>
          {this.getPointerForChapteredVideo()}
        </div>
      </div>
      </>
    );
  }

  getPointerForChapteredVideo() {
    const divSources = [];
    if (
      this.props.data.chapteredVideoData &&
      this.props.data.chapteredVideoData.length > 0 &&
      this.ref.current
    ) {
      let duration: number = 0;
      divSources.push(<div 
        key={Math.floor(Math.random() * 100)} style={{ left: 0 }} className={"RangeComponent__arrow"} />);
      this.props.data.chapteredVideoData.forEach(
        (element: { seconds: number; title: string | undefined }, i: number) => {
          if (i !== this.props.data.chapteredVideoData.length - 1) {
            duration = duration + element.seconds;
            const percent: number = duration / this.props.data.valueMax;
            const nowStyle = this.getWidth() * percent - 2;
            const content = (
              <div
                tabIndex={0}
                key={`${element.title}-${i}`}
                aria-label={element.title}
                style={{ left: nowStyle }}
                className={"RangeComponent__arrow"}
              />
            );
            divSources.push(content);
          }
        },
      );
    }
    return divSources;
  }

  handleMouseAndTouch(event: React.MouseEvent | React.TouchEvent) {
    const t = event.type.toLowerCase();
    if (t === 'mousedown' || t === 'touchstart') {
      this.dragging = true;
    }
    if (this.dragging) {
      if (
        this.props.events &&
        this.props.events.update &&
        (t === 'mouseup' || t === 'touchend')
      ) {
        const timeToSeek = this.reflect(this.process(event));
        this.props.events.update(timeToSeek);
      } else {
        this.reflect(this.process(event));
      }
      // prevents default browser drag/drop of element behaviour
      if (t === 'mousemove' || t === 'touchmove') {
        event.preventDefault();
      }
    }
    if (t === 'mouseup' || t === 'touchend') {
      this.dragging = false;
    }
  }

  handleKeyEvents(event: React.KeyboardEvent) {
    const k: number = event.keyCode;
    const t: string = event.type;
    if (k === 37 || k === 39 || k === 38 || k === 40) {
      if (t === 'keyup') {
        this.dragging = false;
        return;
      }
      this.dragging = true;
      const move = (8 / this.getWidth()) * 100;
      if (k === 37 || k === 40) {
        this.props.events.update(this.reflect(this.value - move));
      } else {
        this.props.events.update(this.reflect(this.value + move));
      }
      event.stopPropagation();
      event.preventDefault();
    }
  }

  getStyle(): any {
    // if (this.dragging) {
    //   this.props.options.reflect = this.value;
    // } else {
    //   // this.value = this.attributes['reflect']
    //   // this.setState({ value: this.props.options.reflect });
    // }
    const percent: number = this.value / 100;
    let toolTipOffset = 0;
    if (this.props.data && this.props.data.mute) {
      this.x = 0;
    } else if (this.ref.current) {
      this.x = this.getWidth() * percent;
      if (this.props?.options?.preview !== null) {
        // toolTipOffset = -150 * (Math.floor(this.attributes['aria-valuemax'] * (this.value/ 100)))
        toolTipOffset = -150 * Math.floor(this.valueMax * (this.value / 100));
      }
    }
    const buttonLeft =
      this.props.data && this.props.data.mute
        ? 0
        : this.x - this.handleWidth * (percent - 0.5) + 'px';
    return {
      bottom: {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0,-50%)',
        width: '100%',
      },
      button: {
        left: buttonLeft,
        position: 'absolute',
        top: '50%',
        transform: 'translate(-50%,-50%)',
      },
      // ghost: {
      //     left: this.ghost.left + 'px',
      //     opacity: this.ghost.show ? .75 : 0,
      //     transform: 'translate(-50%,0%)',
      //     transition: 'opacity .25s',
      //     transitionDelay: this.ghost.show ? '0s' : '0s',
      //     transitionDuration: this.ghost.show ? '0s' : '6s',
      // },
      tooltip: {
        // backgroundImage: this.props.options.preview ? 'url(' + this.props.options.preview.src + ')' : '',
        // backgroundPosition: toolTipOffset + 'px 0px',
        display: this.dragging && this.props?.options?.tooltip ? '' : 'none',
        left: this.x - this.getHandleWidth() * (percent - 0.5) + 'px',
        pointerEvents: 'none',
        userSelect: 'none',
      },
      top: {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0,-50%)',
        width: this.x + 'px',
      },
    };
  }

  private renderToolTipText() {
    switch (this.props?.options?.tooltipFormat) {
      case TooltipFormat.Timecode:
        return Timecode.secondsToTimecode(
          this.props.data.valueMax * (this.value / 100),
        );
      default:
        return this.value;
    }
  }

  private getWidth() {
    const measured = this.ref && this.ref.current && this.ref.current.getElementsByClassName("RangeComponent__bottom")[0]; // || this.element
    if (measured) {
      return measured.getBoundingClientRect().width;
    }
    return 0;
  }
  private getHandleWidth(): number {
    if (!this.handleWidth && this.ref.current) {
      // if (!this.element) return 0;
      let button: any = this.ref && this.ref.current && this.ref.current.getElementsByClassName("RangeComponent__button");
      button = button ? (button[0] as HTMLElement) : null;
      this.handleWidth = button ? button.offsetWidth : 0;
    }
    return this.handleWidth;
  }
  private reflect(value: number): number {
    if (value > 100) {
      value = 100;
    }
    if (value < 0) {
      value = 0;
    }
    this.value = value;
    // this.invalidate();
    this.forceUpdate();
    return (this.props.data.valueMax * value) / 100;
  }
  private process(event: React.MouseEvent | React.TouchEvent): number {
    if (!this.ref.current) {
      return 0;
    }
    const listenToHtml = this.ref && this.ref.current && this.ref.current.getElementsByClassName(
      "RangeComponent__bottom",
    )[0] as HTMLElement;
    let x = 0;
    if (event.nativeEvent instanceof MouseEvent) {
      x = event.nativeEvent.pageX;
    } else if (event.nativeEvent instanceof TouchEvent) {
      if (event.nativeEvent.touches.length) {
        x = event.nativeEvent.touches[0].pageX;
        (this.process as any).lastTouch = event.nativeEvent.touches[0];
      } else {
        x = (this.process as any).lastTouch.pageX;
      }
    } else {
      return 0;
    }
    const offsetX = x - listenToHtml.getBoundingClientRect().left;
    let result =
      (offsetX - this.handleWidth / 2) /
      (listenToHtml.getBoundingClientRect().width - this.handleWidth);
    if (result < 0) {
      result = 0;
    }
    if (result > 1) {
      result = 1;
    }
    return Math.round(result * 100);
  }
}

export default RangeComponent;